import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@/lib/axios";

interface DepartmentResponse {
  data: {
    document: {
      _id: string;
      name: string;
      employees: any[];
      coursesAssignedToDepartment: string[];
      // Add other properties as needed
    };
  };
}

/**
 * Custom hook to fetch department data using React Query
 */
export const useDepartmentData = (departmentId: string, enabled: boolean) => {
  return useQuery<DepartmentResponse>({
    queryKey: ["department", departmentId],
    queryFn: async () => {
      const response = await axiosInstance.get<DepartmentResponse>(
        `/api/v1/departments/${departmentId}`
      );
      return response.data;
    },
    enabled: enabled && !!departmentId,
  });
};
